export const IS_CREATE_COLOR = "IS_CREATE_COLOR";
export const IS_UPDATE_COLOR = "IS_UPDATE_COLOR";
export const COLOR_LIST = "COLOR_LIST";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const AFTER_DELETED = "AFTER_DELETED";
